import { AccountType } from '../service-proxies';


export class AccountDto implements IAccountDto {
    id!: number;
    accountName!: string | undefined;
    accountType!: AccountType;
    openingBalance!: number;
    openingBalanceDate!: Date;
    isActive!: boolean;

    constructor(data?: IAccountDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.accountName = _data["accountName"];
            this.accountType = _data["accountType"];
            this.openingBalance = _data["openingBalance"];
            this.openingBalanceDate = _data["openingBalanceDate"] ? new Date(_data["openingBalanceDate"].toString()) : <any>undefined;
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): AccountDto {
        data = typeof data === 'object' ? data : {};
        let result = new AccountDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["accountName"] = this.accountName;
        data["accountType"] = this.accountType;
        data["openingBalance"] = this.openingBalance;
        data["openingBalanceDate"] = this.openingBalanceDate ? this.openingBalanceDate.toISOString() : <any>undefined;
        data["isActive"] = this.isActive;
        return data; 
    }
}

export interface IAccountDto {
    id: number;
    accountName: string | undefined;
    accountType: AccountType;
    openingBalance: number;
    openingBalanceDate: Date;
    isActive: boolean;
}

